import React from 'react'
import { useEffect, useState } from 'react'
import moment from 'moment'
import { TaskDetails } from './model'
import { colorFromResult, colorFromStatus, sessionTypeToLabel } from './utils'
import {
  Card,
  CardHeader,
  CardBody,
  ListGroupItem,
  ListGroup,
  Table,
  ListGroupItemText,
  ListGroupItemHeading,
} from 'reactstrap'

const client = require('api/auth')

export interface ViewProps {
  logId: number
}
export default function View(props: ViewProps): JSX.Element {
  const [taskDetails, setTaskDetails] = useState<TaskDetails | null>(null)

  const loadTaskDetails = async (logId: number): Promise<TaskDetails> => {
    const token = client && client.getAuthResponse() ? client.getAuthResponse().access_token : null
    if (token) {
      const data = await fetch(`${RESTAURANTS_SVC_API5}/v5/zuppler_logs/${logId}`, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      }).then((res) => res.json())
      return data
    } else {
      throw 'Invalid token to access log'
    }
  }

  useEffect(() => {
    if (props.logId) {
      loadTaskDetails(props.logId).then(setTaskDetails)
    }
  }, [props.logId])
  if (!taskDetails) {
    return <>Loading resources</>
  }
  return (
    <>
      <div className="row">
        <div className="col-6">
          <h5>{sessionTypeToLabel(taskDetails.session_type)} Details</h5>
          <ul className="list-group">
            {[
              ['Started', moment(taskDetails.start_time).format('lll')],
              ['Finished', taskDetails.end_time ? moment(taskDetails.end_time).format('lll') : 'N/A'],
              ['Result', <span className={`${colorFromResult(taskDetails.result)}`}>{taskDetails.result}</span>],
              ['Status', <span className={`${colorFromStatus(taskDetails.status)}`}>{taskDetails.status}</span>],
              ['Message', taskDetails.message || 'N/A'],
            ].map(([label, value]) => (
              <li className="list-group-item" style={{ padding: '0.15rem 0.25rem' }}>
                <span style={{ fontWeight: 'normal' }}>{label}: </span>
                <span style={{ fontWeight: 'bolder' }}>{value}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="col-6">
          <h5>Execution Info</h5>
          <ul className="list-group">
            {taskDetails.steps.map((step) => (
              <li key={step.id} className="list-group-item" style={{ padding: '0.10rem 0.25rem' }}>
                <div className="text text-primary" style={{ fontWeight: 'bolder' }}>
                  {step.step}
                </div>
                <div className="text text-small" style={{ fontSize: 'x-small' }}>
                  {moment(step.inserted_at).format('LTS')} in {step.duration || 0}s
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {taskDetails.assets.length > 0 && (
        <div className="row-fluid">
          <div className="col-12">
            <Table stripped>
              <thead>
                <tr>
                  <th>Asset Name</th>
                  <th>Asset Type</th>
                  <th>Created at</th>
                </tr>
              </thead>
              <tbody>
                {taskDetails.assets.map((asset) => (
                  <tr key={asset.id}>
                    <td>
                      {asset.asset_name}{' '}
                      <a href={asset.url} target="_blank" rel="noreferrer">
                        <i className="fa fa-download" />
                      </a>
                    </td>
                    <td>{asset.asset_type}</td>
                    <td>{moment(asset.inserted_at).format('lll')}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      )}
    </>
  )
}
